import { FC } from 'react'
import { TableSkeleton } from '../../../__legacy__/components/platform/new-explore/components/Table'
import { TableRowHeader } from '../../../__legacy__/components/platform/new-explore/components/TableRow'
import Tabs from '../../../__legacy__/components/platform/new-explore/components/Tabs'
import useSelectedMedia from '../../../__legacy__/components/platform/new-explore/hooks/useSelectedMedia'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { TableRow } from '../../arp-tablerow'
import { EmptyState } from '../../empty-state'
import { useArpDNA, useCSSGradient } from '../hooks'
import { Section } from '../primitives'

export const ArpDNATabContent: FC<{ media: IArpMedia }> = ({ media }) => {
  const { data, status, orderBy, order, handleOrderChange } = useArpDNA(media)
  const { index, handleSelect } = useSelectedMedia({ queueData: data.map((e) => e.id) })
  const { color } = useCSSGradient(media)
  return (
    <Tabs.Content value="#dna">
      <Section.Root>
        <Section.Flare1 css={{ color }} />
        <Section.Flare2 css={{ color }} />
        <Section.Content>
          {status === 'ready' && data.length === 0 ? (
            <EmptyState.Root>
              <EmptyState.Icon />
              <EmptyState.Text muted>No DNA available</EmptyState.Text>
            </EmptyState.Root>
          ) : (
            <>
              <TableRowHeader order={order} orderBy={orderBy} used onSelect={handleOrderChange} />
              {status !== 'ready' && <TableSkeleton size={8} />}
              {data.map((m) => (
                <TableRow.Root media={m} key={m.id}>
                  <TableRow.Main />
                  <TableRow.Tags />
                  <TableRow.DateMinted />
                  <TableRow.Favorite />
                  <TableRow.Remixes />
                  <TableRow.Actions />
                </TableRow.Root>
              ))}
            </>
          )}
        </Section.Content>
      </Section.Root>
    </Tabs.Content>
  )
}
